export const choreManageTranslateEs = {
    CHORE_MANAGE_VIEW:{
        ADD:{
            TITLE: "Agregando nueva misión para",
            BUTTON: "Guardar & asignar",
            TOAST:{
                SUMMARY: "Misión asignada a",
                DETAIL: "Esta misión ha sido asignada"
            }
        },
        LABEL_CHORE_TITLE: "Escribe el nombre de la misión...",
        LABEL_DESCRIPTION: "Descripcion (opcional)",
        LABEL_REWARD: "Monto de la recompensa",
        LABEL_DEADLINE: "Fecha limite",
        PLACE_HOLDER_DEADLINE: "Seleccionar fecha y hora"
    },
}

